// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 681 ? "b4839c76" : chunkId) + "." + {"681":"d86a4cb319cf1194","826":"9648b59d48595d33"}[chunkId] + ".js";
};